import { addFuel, deleteFuelById, getAllFuel, getFuelById, updateFuel } from "../../../helpers/backend_helper";
import { fuelError, fuelRequest, fuelSuccess, getFuelByIdError, getFuelByIdSuccess } from "./reducer";

export const fetchFuel = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(fuelRequest());
    try {
      const response: any = await getAllFuel(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(fuelSuccess(response.data));
        return response
      } else {
        dispatch(fuelError("Failed to fetch Fuel"));
        return response
      }
    } catch (error: any) {
      dispatch(fuelError(error.message));
      return null
    }
  };


 export const addNewFuel = (data: any) => async (dispatch: any) => {
    dispatch(fuelRequest());
    try {
      const response: any = await addFuel(data);
      if (response && response.data) {
        dispatch(fuelSuccess(response.data));
        return response 
      } else {
        dispatch(fuelError("Failed to add maintenance"));
      }
    } catch (error: any) {
      dispatch(fuelError(error.message));
    }
  };
  
  export const editFuel = (data: any) => async (dispatch: any) => {
    dispatch(fuelRequest());
    try {
      const response: any = await updateFuel(data);
      if (response.data && response.isSuccess) {
        dispatch(fuelSuccess(response));
        return response 
      } else {
        dispatch(fuelError("Failed to edit maintenance"));
        return response 
      }
    } catch (error: any) {
      dispatch(fuelError(error.message));
      return null
    }
  };
 
  export const fetchFuelById = (userId: string) => async (dispatch: any) => {
    dispatch(fuelRequest());
    try {
      const response: any = await getFuelById(userId);  
  
      if (response && response.isSuccess) {
        dispatch(getFuelByIdSuccess(response.data)); 
        return response;  
      } else {
        dispatch(getFuelByIdError("Failed to fetch Fuel by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(getFuelByIdError(error.message));  
      return null;
    }
  };  

  export const deleteFuel = (fuelId: string) => async (dispatch: any) => {
    dispatch(fuelRequest());
    try {
      const response: any = await deleteFuelById(fuelId);
      if (response && response.isSuccess) {
        dispatch(fuelSuccess(response.data));
        return response 
      } else {
        dispatch(fuelError("Failed to delete Fuel"));
        return null
      }
    } catch (error: any) {
      dispatch(fuelError(error.message));
      return null
    }
  }